import MyModal from "components/MyModal";
import MyTable from "components/Table";
import moment from "moment";
import React, { useState } from "react";
import { InvoiceDetails } from "./InvoiceDetails";
import { PaymentStatus } from "./PaymentStatus";
import { LinkStyle } from "./Theme";
import { DateFormetContext } from "../../../../app/App.js";

const OpenedInvoices = ({ setSelectionModel, ...props }) => {
  const dateFormet = React.useContext(DateFormetContext);
  const [openModal, setOpenModal] = useState(false);
  const [pageSize, setPageSize] = useState(5);
  const [invoiceId, setInvoiceId] = useState("");

  const columns = [
    {
      field: "inv__id",
      resizable: true,
      headerName: " ",
      minWidth: 50,
      sortable: false,
      renderCell: (data) => {
        return <div style={{ fontSize: "14px" }}>{data?.row?.inv_id}</div>;
      },
    },
    {
      field: "inv_issue_date",
      resizable: true,
      headerName: "ISSUES DATE",
      sortable: false,
      minWidth: 150,
      flex: 1,

      renderCell: (data) => {
        return (
          <div style={{ fontSize: "14px", color: "#575757" }}>
            {moment(data?.row?.inv_issue_date)
              .utcOffset("+0100")
              .format(dateFormet)}
          </div>
        );
      },
    },
    {
      field: "inv_due_date",
      resizable: true,
      headerName: "DUE DATE",
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: (data) => (
        <div style={{ fontSize: "14px", color: "#575757" }}>
          {moment(data?.row?.inv_due_date)
            .utcOffset("+0100")
            .format(dateFormet)}
        </div>
      ),
    },
    {
      field: "date_balance",
      resizable: true,
      headerName: "DATE BALANCE",
      sortable: false,
      minWidth: 150,
      flex: 1,
      renderCell: (data) => (
        <div style={{ fontSize: "14px", color: "#7EDC90" }}>
          {moment(data?.row?.inv_due_date).diff(
            moment(data?.row?.inv_issue_date),
            "days"
          )}
          {` days left`}
        </div>
      ),
    },
    {
      field: "memberName",
      resizable: true,
      headerName: "MEMBER NAME",
      sortable: false,
      minWidth: 150,
      flex: 1,
      renderCell: (data) => (
        <div style={{ fontSize: "14px", color: "#000000", width: "100%" }}>
          {data?.row?.memberDetails?.member_name && (
            <div style={{ lineHeight: "15px" }}>
              {data?.row?.memberDetails?.member_name}
            </div>
          )}
          {data?.row?.memberDetails?.member_serial && (
            <div style={{ lineHeight: "15px", color: "#2455EF" }}>
              #{data?.row?.memberDetails?.member_serial}
            </div>
          )}
        </div>
      ),
    },
    {
      field: "TOTAL",
      resizable: true,
      headerName: "TOTAL",
      sortable: false,
      minWidth: 70,
      flex: 1,
      renderCell: (data) => (
        <div style={{ fontSize: "14px", color: "#4CAF50" }}>
          <span>${data?.row?.payment_amount?.total}</span>
        </div>
      ),
    },
    {
      field: "status",
      resizable: true,
      headerName: "STATUS",
      sortable: false,
      minWidth: 70,
      flex: 1,
      renderCell: (data) => (
        <PaymentStatus
          type={
            data?.row?.payment_amount?.payment_status === "UnPaid"
              ? "Open"
              : "Paid"
          }
        />
      ),
    },
    {
      field: "action",
      resizable: true,
      headerName: `${" "}`,
      sortable: false,
      minWidth: 150,
      cellClassName: "line-h",

      renderCell: (data) => (
        <LinkStyle
          onClick={() => {
            setInvoiceId(data?.row?._id);
            setOpenModal(true);
          }}
        >
          View Details
        </LinkStyle>
      ),
    },
  ];

  return (
    <div className="activated-ledger">
      <div className="ledger-table" style={{ height: "fit-content" }}>
        <div className="home-table-container mt-0 ">
          <MyTable
            className="family-table"
            rows={props.FList}
            checkboxSelection
            columns={columns}
            pageSize={pageSize}
            loading={props.loading}
            onPageChange={(pageNum) => {
              props.setPage(pageNum);
            }}
            disableSelectionOnClick
            onPageSizeChange={(num) => setPageSize(num)}
            rowHeight={70}
            paginationMode="server"
            rowCount={props.FTotal}
            pagination
            onSelectionModelChange={(newSelectionModel) => {
              setSelectionModel(newSelectionModel);
            }}
          />
        </div>
      </div>
      <MyModal
        className="invoice-details-modal"
        open={openModal}
        onClose={() => setOpenModal(false)}
        style={{ maxWidth: "80% !important" }}
      >
        <InvoiceDetails {...{ invoiceId }} />
      </MyModal>
    </div>
  );
};
export default OpenedInvoices;
